const initialState = {
    profile: {
        username: '',
        email: '',
        gambar: '',
        token: ''
    },
    login: false,
    ResponseLogin: ''
}


const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_CHANGE":
            return {
                ...state,
                login: action.payload
            }
        case "RESPONSE_LOGIN":
            return{
                ...state,
                ResponseLogin: action.payload
            }
        default:
            return state
    }

}

export default sessionReducer